module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-15-3692e335af9157125178711e455423bc.jpg";